import './action-card.scss';

import { LinkCard } from '../link-card/link-card';

export type ActionCardProps = {
  icon?: React.ReactNode;
  title: string;
  subtitle?: string;
  href: string;
  onClick?: () => void;
  className?: string;
};

export const ActionCard: React.FC<ActionCardProps> = ({
  icon,
  title,
  subtitle,
  href,
  onClick,
}) => {
  return (
    <LinkCard
      href={href}
      onClick={onClick}
      className="ActionCard"
      graphic={
        icon ? (
          <div className="ActionCard__icon w-12 h-12 p-comfy-xs rounded-md">
            {icon}
          </div>
        ) : undefined
      }
    >
      <div className="ActionCard__title label-potent label-md md:label-lg md:label-potent">
        {title}
      </div>
      {subtitle && (
        <div className="ActionCard__subtitle label-moderate label-md md:label-lg md:label-moderate">
          {subtitle}
        </div>
      )}
    </LinkCard>
  );
};
